import { defaultTo, get } from 'lodash';

import {
  PROJECTION_CAPABLE,
  POTS_CAPABLE,
  LIMITED_READ,
} from '../constants/AccountCapability';

const getActionsAvailable = (accountOrUserData) =>
  defaultTo(
    get(accountOrUserData, 'actionsAvailable'),
    get(accountOrUserData, 'actions_available')
  );

export const accountHasProjections = (account) =>
  get(getActionsAvailable(account), PROJECTION_CAPABLE, false);
export const accountHasSavingsPot = (account) =>
  get(getActionsAvailable(account), POTS_CAPABLE, false);
export const accountHasLimitedRead = (account) =>
  get(getActionsAvailable(account), LIMITED_READ, false);
